import OrderChangeQuantity from "../symbols/orderChangeQuantity";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function OrderChangeQuantityReducer(state = initialState, action: any) {
  switch (action.type) {
    case OrderChangeQuantity.ORDER_CHANGE_QUANTITY:
      return { ...state, loading: true, error: false };
    case OrderChangeQuantity.ORDER_CHANGE_QUANTITY_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case OrderChangeQuantity.ORDER_CHANGE_QUANTITY_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case OrderChangeQuantity.CLEAR_ORDER_CHANGE_QUANTITY:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default OrderChangeQuantityReducer;
